<script>
export default {
    name: "VisitReportPrint",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {
        Promise.allSettled([ this.fetchPatients(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatients() {

            let url = `PatientsReports/GetPatientsAdmssionReport?dateFrom=${this.$route.query.dateFrom}&dateTo=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            
            return this.$http.get(url).then(response => {
                        this.patients = response.data;
                    }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="flex-1 text-center my-2">
            <h5 class="font-medium uppercase">Admission Report</h5>
        </div>
        <table class="table table-hover">
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex">
                    <th class="p-tiny flex-1">NO</th>
                            <th class="p-tiny flex-1">Admission Date</th>
                            <th class="p-tiny flex-1">Discharge Date</th>
                            <th class="p-tiny flex-1">Member No</th>
                            <th class="p-tiny flex-1">IP No</th>
                            <th class="p-tiny w-1/6">Name</th>
                </tr>
                <tr class="flex w-full" v-for="(patient, idx) in patients" :key="idx">
                    <td class="p-tiny flex-1">{{ patient.notificationNo }}</td>
                          <td class="p-tiny flex-1">{{ patient.admissionDate | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ patient.dischargeDate | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ patient.memberNo }}</td>
                          <td class="p-tiny flex-1">{{ patient.ipNo }}</td>
                          <td class="p-tiny w-1/6"> {{ patient.patientName }}</td>
                      </tr>
                <tr class="flex w-full">
                    <th class="p-tiny w-1/2"></th>
                    <th class="p-tiny w-1/2 text-right">Total Admissions: 
                      {{ patients ? patients.length : 0 }}</th>
                </tr>
            </tbody>
        </table>
    </div>
</template>